export default __webpack_public_path__ + "static/media/o15.072f6665.jpg";